export default {
    props: {
        footerLink: {
            type: Object,
            require: true
        }
    },
    template: `
    <a
        class="link"
        :href="footerLink.link" 
        :target="footerLink.target" 
    >
        {{ footerLink.title }}
    </a>
    `
}